// extracted by mini-css-extract-plugin
export default {"card":"page_card__mhn-N","title":"page_title__cd4kv","controls":"page_controls__cgkai","control":"page_control__Zo3zi"};